import { EmbeddedVideosFiltersEnum } from "features/Library/EmbeddedVideos/types/models";
import { FilterViewTypes } from "../../../enums/filterViewTypes";
import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";

export const getEmbeddedVideosFilters = (
  includePublisher: boolean = true,
  disableDateFilters: boolean = false,
): FilterItemBase<EmbeddedVideosFiltersEnum>[] => {
  let filters: FilterItemBase<EmbeddedVideosFiltersEnum>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: EmbeddedVideosFiltersEnum.DateCreated,
      otherProps: { disabled: disableDateFilters },
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: EmbeddedVideosFiltersEnum.DateModified,
      otherProps: { disabled: disableDateFilters },
    },
  ];

  if (includePublisher) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: EmbeddedVideosFiltersEnum.Publishers,
      placeholder: "All Publishers",
    });
  }

  filters.push(
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: EmbeddedVideosFiltersEnum.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: EmbeddedVideosFiltersEnum.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: EmbeddedVideosFiltersEnum.Labels,
      placeholder: "All Labels",
    },
  );

  return filters;
};
